<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="modalData.title"
        :show-close="false"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <div class="clearfix">
            <div v-if="modalData.name=='yy_type'">
                <el-form ref="form" label-width="80px" label-position="left" class="pr40">
                    <el-form-item label="维度：" class="label-required">
                        <ESelect v-model="formItem.select" @change="changeSelect" :disabled="isView" placeholder="请选择">
                            <el-option
                                v-for="item in optionList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </ESelect>
                    </el-form-item>
                </el-form>
            </div>
            <div class="search-wrap fl">
                <div>
                    <div class="relative" :class="[isAutoLoad?'ml60':'ml30']">
                        <el-dropdown @command="changeIsExclude" :disabled="isView" class="exclude-drop" :class="isAutoLoad?'':'left30'" trigger="click" placement="bottom-start">
                            <span class="el-dropdown-link">
                                <span v-if="formItem.isExclude && modalData.name != 'time_zone' " class="icon iconfont icon-jt-paichu text-color-error" title="排除"></span>
                                <span v-else class="icon iconfont icon-jt-invert-full active-icon" title="包含"></span>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command=""><span :class="formItem.isExclude?'':'active-icon'" class="icon iconfont icon-jt-invert-full ver-middle"></span> 包含</el-dropdown-item>
                                <el-dropdown-item  v-if="modalData.name != 'time_zone'" command="exclude" class="text-color-error"><span class="icon iconfont icon-jt-paichu ver-middle"></span> 排除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <span class="copy-btn-icon el-icon-document-copy" @click="showBatchModal" title="批量选择" v-if="isAutoLoad"></span>
                        <el-input v-model="formItem.search" ref="searchInput" @input="changeSearchText" :autofocus="true" clearable placeholder="请输入查询关键字"></el-input>
                    </div>
                    <div class="search-list"  @scroll="scrollList">
                        <ul v-loading="dataList.length<=0&&searchLoading">
                            <li class="mt4 mb4" v-if="dataList.length>0&&formItem.search.length>0">
                                <el-checkbox v-model="isSelectAll" :disabled="isView" @change="selectAll">全选</el-checkbox>
                            </li>
                            <li class="mt4 mb4" v-for="(item,index) in dataList" :key="item.id+''+index" :class="item.isHide?'hide-item':''">
                                <el-checkbox v-model="item.checked" :disabled="isView" @change="itemCheckChange(item,$event)">
                                    {{item.name}}
                                </el-checkbox>
                            </li>
                            <li class="mt4 mb4" v-if="!searchLoading&&dataList.length<=0">
                                <p class="tac">暂无数据</p>
                            </li>
                            <li class="mt4 mb4" v-if="searchLoading">
                                <p class="tac text-color-gray">数据加载中...</p>
                            </li>
                            <li class="mt4 mb4" v-if="isEnd">
                                <p class="tac text-color-gray">没有更多了</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="result-wrap fl">
                <h3 class="font12px relative">已选条件（{{resultList.length}}） <span
                    class="text-color-error pointer absolute " v-show="!isView" style="right:10px;" @click="clearResultList">清空</span>
                </h3>
                <div class="result-list">
                    <ul>
                        <li v-for="(item,index) in resultList" :key="item.id+''+index" class="relative mt4 mb4 font12px">{{item.name}}
                            <span class="clear-btn pointer text-color-error p4 absolute" @click="clearResultItem(item)"
                                  title="删除" v-show="!isView">x</span>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
        <div slot="footer" class="dialog-footer tac">
            <template v-if="isView">
                <el-button type="primary" @click="hideModal" class="action-btn ml20">关闭</el-button>
            </template>
            <template v-else>
                <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
                <el-button type="primary" @click="handleSubmit" :disabled="searchLoading" :loading="submitLoading" class="action-btn ml20">确认</el-button>
            </template>
        </div>

        <el-dialog
            width="520px"
            :title="'批量选择'+modalData.title"
            :visible.sync="batchVisible"
            :show-close="false"
            class="batch-modal"
            append-to-body>
            <div>
                <p class="text-color-gray mb10">输入或粘贴{{modalData.title}}，每行一个</p>
                <div class="batch-content">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="batchCon"
                        :rows="10"
                        resize="none"
                        style="min-height: 200px;"
                        :autofocus="true"
                    >
                    </el-input>
                </div>
                <p class="tac mt20">
                    <el-button type="default" @click="hideBatchModal" class="action-btn mr20">取消</el-button>
                    <el-button type="primary" @click="submitBatchModal" :loading="batchLoading" class="action-btn ml20">提交
                    </el-button>
                </p>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import API from '@/api/efficiencyTool/template_new.js';

    export default {
        name: "ContentModal",
        components: {},
        props: {
            modalData: {
                type: Object,
                required: true,
            },
            condition:{
                type: Array,
                required: true,
            },
            platId:{
                type: [String,Number],
                required: true,
            },
            autoLoadFields:{
                type: Array,
                required: true,
            },
            isTimeFilter:{
                required: false,
                type:Boolean,
                default:false,
            },
        },
        data() {
            return {
                dialogVisible: false,
                autoLoading:false,
                submitLoading: false,
                searchLoading: false,
                formItem: {
                    search: '',
                    isExclude:false,
                    select:'',
                },
                dataList: [],
                resultList: [],
                isSelectAll: false,
                searchTimer:null,
                isEnd:false,
                isAutoLoad:false,
                batchVisible:false,
                batchCon:'',
                batchLoading:false,
                optionList:[],
                ajaxController:null,
                lastSelectVal:'',
            }
        },
        computed: {
            platTimeInterval(){
                if(!this.isTimeFilter) return '';
                return 'hour';
            },
            excludeConditionFields(){
                let conConditions = this.condition.filter(item=>{
                    let fieldConfig = item.config||{};
                    return fieldConfig.type==='content';
                });
                return conConditions.filter(item=>item.isExclude).map(item=>item.name);
            },
            isView(){
                return this.modalData.type == 'info';
            },
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
                clearTimeout(this.searchTimer);
                this.$emit('close',this.modalData);
            },
            resetForm() {
                this.formItem.search = '';
                this.formItem.isExclude = false;
                this.searchLoading = false;
                this.autoLoading = false;
                this.searchTimer = null;
                this.dataList = [];
                this.resultList = [];
            },
            hideModal(){
                this.handleClose();
                // this.$emit('close',this.modalData);
            },
            showModal() {
                this.dialogVisible = true;
                /* 设置自代运营 */
                if(this.modalData.name=='yy_type'){
                    if(this.platId=='3'){
                        this.optionList = [
                            {
                                value:'bloc_yy_type',
                                label:'按集团',
                            },
                            {
                                value:'company_yy_type',
                                label:'按客户',
                            },
                            {
                                value:'account_yy_type',
                                label:'按账户',
                            },
                            {
                                label:'按项目',
                                value:'project_yy_type',
                            },
                            {
                                label:'按推广',
                                value:'subproject_yy_type',
                            },
                            {
                                value:'app_yy_type',
                                label:'按产品',
                            },
                            {
                                value:'plan_yy_type',
                                label:'按计划',
                            },
                            {
                                value:'adgroup_yy_type',
                                label:'按广告组',
                            },
                            {
                                value:'ad_yy_type',
                                label:'按广告',
                            },
                            {
                                value:'idea_yy_type',
                                label:'按创意',
                            },
                        ];
                    }else if(this.platId=='4'){
                        this.optionList = [
                            {
                                label:'按集团',
                                value:'bloc_yy_type',
                            },
                            {
                                label:'按客户',
                                value:'company_yy_type',
                            },
                            {
                                label:'按项目',
                                value:'project_yy_type',
                            },
                            {
                                label:'按账户',
                                value:'account_yy_type',
                            },
                            {
                                label:'按推广',
                                value:'subproject_yy_type',
                            },
                            {
                                label:'按产品',
                                value:'app_yy_type',
                            },
                            {
                                label:'按任务',
                                value:'task_yy_type',
                            },
                            {
                                label:'按子任务',
                                value:'sub_task_yy_type',
                            },
                        ];
                    }else if(this.platId=='8'){
                        this.optionList = [
                            {
                                value:'bloc_yy_type',
                                label:'按集团',
                            },
                            {
                                value:'company_yy_type',
                                label:'按客户',
                            },
                            {
                                value:'account_yy_type',
                                label:'按账户',
                            },
                            {
                                label:'按项目',
                                value:'project_yy_type',
                            },
                            {
                                label:'按推广',
                                value:'subproject_yy_type',
                            },
                            {
                                value:'app_yy_type',
                                label:'按产品',
                            },
                            {
                                value:'plan_yy_type',
                                label:'按广告系列',
                            },
                            {
                                value:'adgroup_yy_type',
                                label:'按广告',
                            },
                            {
                                value:'ad_yy_type',
                                label:'按创意',
                            },
                        ];
                    } else if(this.platId=='9'){
                        this.optionList = [
                            {
                                value:'bloc_yy_type',
                                label:'按集团',
                            },
                            {
                                value:'company_yy_type',
                                label:'按客户',
                            },
                            {
                                value:'account_yy_type',
                                label:'按广告系列组',
                            },
                            {
                                label:'按项目',
                                value:'project_yy_type',
                            },
                            {
                                label:'按推广',
                                value:'subproject_yy_type',
                            },
                            {
                                value:'app_yy_type',
                                label:'按产品',
                            },
                            {
                                value:'plan_yy_type',
                                label:'按广告系列',
                            },
                            {
                                value:'adgroup_yy_type',
                                label:'按广告组',
                            },
                            {
                                label:'按关键词',
                                value:'keyword_yy_type',
                            },
                        ];
                    }else if(this.platId=='7'){
                        this.optionList = [
                            {
                                value:'bloc_yy_type',
                                label:'按集团',
                            },
                            {
                                value:'company_yy_type',
                                label:'按客户',
                            },
                            {
                                value:'account_yy_type',
                                label:'按账户',
                            },
                            {
                                value:'project_yy_type',
                                label:'按项目',
                            },
                            {
                                value:'subproject_yy_type',
                                label:'按推广',
                            },
                            {
                                value:'app_yy_type',
                                label:'按产品',
                            },
                            {
                                value:'plan_yy_type',
                                label:'按计划',
                            },
                            {
                                value:'adgroup_yy_type',
                                label:'按广告组',
                            },
                            {
                                value:'ad_yy_type',
                                label:'按创意',
                            },
                        ];
                    }else if(this.platId=='12'){
                        this.optionList = [
                            {
                                value:'bloc_yy_type',
                                label:'按集团',
                            },
                            {
                                value:'company_yy_type',
                                label:'按客户',
                            },
                            {
                                value:'account_yy_type',
                                label:'按账户',
                            },
                            {
                                value:'project_yy_type',
                                label:'按项目',
                            },
                            {
                                value:'adgroup_yy_type',
                                label:'按广告组',
                            },
                            {
                                value:'ad_yy_type',
                                label:'按创意',
                            },
                        ];
                    }else{
                        this.optionList = [
                            {
                                value:'bloc_yy_type',
                                label:'按集团',
                            },
                            {
                                value:'company_yy_type',
                                label:'按客户',
                            },
                            {
                                value:'account_yy_type',
                                label:'按账户',
                            },
                            {
                                label:'按项目',
                                value:'project_yy_type',
                            },
                            {
                                label:'按推广',
                                value:'subproject_yy_type',
                            },
                            {
                                value:'app_yy_type',
                                label:'按产品',
                            },
                            {
                                value:'plan_yy_type',
                                label:'按计划',
                            },
                            {
                                value:'adgroup_yy_type',
                                label:'按广告组',
                            },
                            {
                                value:'ad_yy_type',
                                label:'按创意',
                            },
                        ];
                    }
                }
                this.formItem.select = this.modalData.selectValue||'account_yy_type';
                this.lastSelectVal = this.formItem.select;


                this.resultList = (this.modalData.contentValue||[]).map(item=>{
                    item.checked = true;
                    return item;
                });
                this.getConditions('','');
                this.resetAllState();
                this.isAutoLoad =  this.autoLoadFields.includes(this.modalData.name);
                this.formItem.isExclude = !!this.modalData.isExclude;

            },
            changeSelect(val){
                console.log('changeSelect',val);
                this.resetForm();
                this.getConditions('','');
            },
            handleSubmit() {
                if(!this.isView){
                    let selectItem = this.optionList.find(item=>item.value==this.formItem.select)||{};
                    this.$emit('save-value',Object.assign({},this.modalData,{
                        isExclude:this.formItem.isExclude,
                        select:this.formItem.select,
                        selectLabel:selectItem.label,
                    }),this.resultList,'content');
                }
                this.handleClose();
            },
            getConditions(type,searchText) {
                if (this.ajaxController) this.ajaxController.abort();
                this.ajaxController = new AbortController();
                let conditionData = {};
                this.condition.forEach(item=>{
                    let config = item.config||{};
                    if(config.type=='date_select'){
                        conditionData[item.name] = item.dateValue.join('/');
                        if(item.name=='start_date'){
                            conditionData.start_date_dimension = item.selectValue;
                        }else if(item.name=='create_date'){
                            conditionData.create_date_dimension = item.selectValue;
                        }
                    }else if(config.type=='date'){
                        conditionData[item.name] = item.dateValue.join('/');
                    }else if(config.type=='time'){
                        conditionData[item.name] = item.timeValue.join('/');
                    }else if(config.type=='select'){
                        conditionData[item.name] = item.selectValue;
                    }else{
                        if(item.name=='yy_type'){
                            conditionData.yy_type_dimension = item.selectValue;
                        }
                        conditionData[item.name] = (item.contentValue||[]).map(item=>item.id);
                    }
                });

                if(!(type&&type==='append')){
                    this.dataList = [];
                }
                this.isEnd = false;


                // let searchText = this.formItem.search;

                let returnName = this.modalData.name=='yy_type'?this.modalData.name+'|'+this.formItem.select:this.modalData.name;

                let reqData = {
                    plat_id: this.platId,
                    search: searchText,
                    return_condition: returnName,
                    condition:conditionData,
                    exclude_condition_fields:this.excludeConditionFields.join(','),
                    last:this.dataList.length>0&&this.isAutoLoad&&!searchText?this.dataList[this.dataList.length-1].id:'',
                    signal: this.ajaxController.signal
                };
                if(this.isTimeFilter){
                    reqData.time_interval = this.platTimeInterval;
                }
                this.searchLoading = true;
                API.postTemplateCondition(reqData).then(res => {
                    console.log('getContentSearch',this.formItem.search,'、',searchText);

                    this.searchLoading = false;
                    this.autoLoading = false;
                    let resData = (res.data||{}).list||[];

                    this.$refs.searchInput.focus();

                    if(searchText==this.formItem.search){
                        if(type&&type==='append'){
                            /* 当最后一个为空时,可能会触发无限自动加载，因此如果返回列表已经全部在列表中存在时，就认为到底了 */
                            let isAllInList = resData.map(item=>item.id).filter(item=>!!item).every(item=>this.dataList.map(item=>item.id).includes(item));
                            if(isAllInList||resData.length<=0){
                                clearTimeout(this.searchTimer);
                                this.searchTimer = null;
                                this.isEnd = true;
                            }
                            resData.forEach(item=>{
                                if(!this.dataList.map(item=>item.id).includes(item.id)){
                                    item.id = item.id===null?'':item.id;
                                    item.checked = !!this.resultList.find(inner => inner.id == item.id);
                                    item.isHide = false;
                                    this.dataList.push(item)
                                }
                            });
                        }else {
                            this.dataList = resData.map(item=>{
                                item.id = item.id===null?'':item.id;
                                item.name = item.name||item.id||'';
                                item.checked = !!this.resultList.find(inner => inner.id == item.id);
                                item.isHide = false;
                                return item;
                            })
                        }
                        this.resetAllState();
                    }else{
                        /*表示searchText跟当前input最新值不一致，说明有新的请求，维持loading状态*/
                        this.searchLoading = true;
                    }
                }, (err) => {
                    console.log('getConditions error', err);
                    this.searchLoading = false;
                    this.autoLoading = false;
                    this.dataList = [];
                    // this.$message.error(err.info||'请求有误');
                    let errCondition = err.data || [];
                    if (errCondition.length > 0) {

                        let errStr = '';
                        errCondition.forEach(item=>{
                            errStr = errStr + `<p class="pb6"><span class="text-bold">${item.err_title}</span>${(item.err_msg||[]).join('，')}</p>`;
                        });
                        let htmlStr = `<div class="tal" style="max-height: 300px;overflow: auto;">${errStr}</div>`;

                        this.$confirm(htmlStr, '以下已选条件无权限', {
                            showCancelButton: false,
                            confirmButtonText: '我知道了',
                            type: 'error',
                            center: true,
                            dangerouslyUseHTMLString: true,
                            showClose: false,
                            distinguishCancelAndClose: true,
                            closeOnClickModal: false,
                            closeOnPressEscape: false,
                        });
                    }else{
                        this.$message.error(err.info||'请求有误');
                    }
                });
            },
            clearResultList() {
                this.resultList = [];
                this.dataList.forEach(item => {
                    item.checked = false;
                });
                this.isSelectAll = false;
            },
            clearResultItem(item) {
                let searchIndex = this.dataList.findIndex(inner => inner.id == item.id);
                let resultIndex = this.resultList.findIndex(inner => inner.id == item.id);
                if (resultIndex != '-1') {
                    this.resultList.splice(resultIndex, 1);
                }
                if (searchIndex != '-1') {
                    this.dataList.find(inner => inner.id == item.id).checked = false;
                }
                this.resetAllState();
            },
            itemCheckChange(item, val) {
                let resultIndex = this.resultList.findIndex(inner => inner.id == item.id);
                if (val) {
                    if (resultIndex == '-1') {
                        this.resultList.unshift(item);
                    }
                } else {
                    if (resultIndex != '-1') {
                        this.resultList.splice(resultIndex, 1);
                    }
                }
                this.resetAllState();
            },
            selectAll(val) {
                this.dataList.forEach(item => {
                    if(!item.isHide){
                        item.checked = val;
                        this.itemCheckChange(item, val);
                    }
                });
            },
            resetAllState() {
                let selectedList = this.dataList.filter(item=>!item.isHide);
                this.isSelectAll = selectedList.length>0&&selectedList.every(item => item.checked);
            },
            changeSearchText(val){
                if(this.isAutoLoad){
                    if(this.searchTimer){
                        clearTimeout(this.searchTimer);
                        this.searchTimer = null;
                    }
                    this.searchTimer = setTimeout(()=>{
                        this.getConditions('',val);
                    },300)
                }else{
                    this.dataList.forEach(item=>{
                        item.isHide = !(item.name||'').toLowerCase().includes(val.toLowerCase());
                    });
                    this.resetAllState();
                }
            },
            scrollList(e){
                if(this.formItem.search!='') return;
                if(!this.isAutoLoad) return;
                let $searchBox = e.target;
                let $ul = $searchBox.querySelector('ul');
                let $ulHeight = $ul.clientHeight;
                if($searchBox.scrollTop>0){
                    if($ulHeight-$searchBox.clientHeight<$searchBox.scrollTop-15){
                        // console.log('到底了');
                        if(this.autoLoading) return ;
                        if(this.isEnd) return;
                        if(this.searchTimer){
                            clearTimeout(this.searchTimer);
                            this.searchTimer = null;
                        }
                        this.searchTimer = setTimeout(()=>{

                            this.autoLoading = true;
                            this.getConditions('append',this.formItem.search);
                        },300)
                    }

                }

            },
            showBatchModal(){
                console.log('showBatchModal');
                this.batchVisible = true;

            },
            hideBatchModal(){
                this.batchVisible = false;
                this.batchCon = '';
            },
            submitBatchModal(){
                console.log('submitBatchModal',this.batchCon.split(/\n/));
                let batchSearch = this.batchCon.split(/\n/).map(item=>item.trim()).filter(item=>!!item);
                if(batchSearch.length<=0){
                    return this.hideBatchModal();
                }
                this.batchLoading = true;

                let conditionData = {};

                this.condition.forEach(item=>{
                    let config = item.config||{};
                    if(config.type=='date_select'){
                        conditionData[item.name] = item.dateValue.join('/');
                        if(item.name=='start_date'){
                            conditionData.start_date_dimension = item.selectValue;
                        }
                    }else if(config.type=='date'){
                        conditionData[item.name] = item.dateValue.join('/');
                    }else if(config.type=='time'){
                        conditionData[item.name] = item.timeValue.join('/');
                    }else if(config.type=='select'){
                        conditionData[item.name] = item.selectValue;
                    }else{
                        conditionData[item.name] = (item.contentValue||[]).map(item=>item.id);
                    }
                });

                let reqData = {
                    plat_id: this.platId,
                    batch_search:batchSearch,
                    return_condition: this.modalData.name,
                    condition:conditionData,
                    exclude_condition_fields:this.excludeConditionFields.join(','),
                };

                if(this.platId=='9'){
                    reqData.time_zone = this.timeZone;
                }
                if(this.isTimeFilter){
                    reqData.time_interval = this.platTimeInterval;
                }

                API.postTemplateCondition(reqData).then(res => {
                    this.batchLoading = false;
                    let resData = res.data || {};
                    let successList = resData.list||[];
                    let errList = resData.err_list||[];

                    if(errList.length>0){

                        let htmlStr = `<div style="max-height: 150px;overflow: auto;">`;
                        let titleTxt = this.modalData.title;
                        htmlStr += '<p>未找到以下'+titleTxt+'，请核实，是否需要剔除未找到的'+titleTxt+'?</p>';
                        htmlStr += '<p class="font12px">'+(errList.join('、'))+`</p></div>`;
                        this.$confirm(htmlStr, '提示', {
                            confirmButtonText: '剔除',
                            cancelButtonText: '关闭',
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            customClass:'batch-err-tips-modal',
                            width:'500',
                        }).then(()=>{
                            this.batchCon = batchSearch.filter(item=>!errList.includes(item)).join('\n');
                            this.submitBatchModal();
                        });
                    }else{
                        console.log('successList',successList);

                        successList.forEach(item=>{
                            let resultItem = this.resultList.find(inner=>inner.id==item.id);
                            let dataItem = this.dataList.find(inner=>inner.id==item.id);
                            if(!resultItem){
                                this.resultList.push({
                                    checked:true,
                                    id:item.id,
                                    isHide:false,
                                    name:item.name,
                                });
                            }
                            if(dataItem){
                                dataItem.checked = true;
                            }

                        });
                        this.batchLoading = false;
                        this.batchVisible = false;
                        this.batchCon = '';
                    }

                    this.resetAllState();
                }, (err) => {
                    console.log('getConditions batch error', err);
                    this.batchLoading = false;
                    this.$message.error(err.info||'请求有误');
                });
            },
            changeIsExclude(command){
                this.formItem.isExclude = command==='exclude';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        /*width: 120px;*/
    }

    ::v-deep .el-dialog__body {
        padding: 20px;
    }

    .copy-btn-icon{
        position: absolute;
        display: inline-block;
        width: 20px;
        height: 20px;
        left: -30px;
        top: 8px;
        font-size: 20px;
        cursor: pointer;
        color: #409eff;
    }

    .result-wrap, .search-wrap {
        width: 50%;
        border: solid 1px #ccc;
        padding: 10px;
        height: 300px;
        overflow: hidden;
    }

    .result-wrap {
        position: relative;
        left: -1px;
    }

    .result-list {
        margin-top: 5px;
        height: 265px;
        overflow-y: auto;
        li{
            white-space: normal;
            line-height: 20px;
            padding: 0 20px 0 10px;
            &:hover{
                background-color: #f8f8f9;
            }
        }
        .clear-btn{
            padding: 0 8px;
            right: 0;
            top: 0;
        }
    }


    .search-list {
        width: 100%;
        min-height: 200px;
        max-height: 250px;
        overflow-y: auto;
        padding: 6px;
        ul{
            min-height: 100px;
        }
    }

    .hide-item{
        display: none;
    }

    .size18{
        font-size: 18px;
    }
    .active-icon{
        color: #409eff;
    }
    .ver-middle{
        vertical-align: middle;
    }
    .left30{
        left: -30px!important;
    }

    .exclude-drop{
        position: absolute;
        left: -60px;
        top: 8px;
        cursor: pointer;
    }



</style>
